import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { currentMedicationsData } from '__mocks__/mockData/current-medications-data';

const CurrentMedications = [
  rest.get(`${API_ROOT}current-medications`, (req, res, ctx) => {
    const patientId = req.url.searchParams.get('patientId');
    if (patientId) {
      return res(ctx.json(currentMedicationsData));
    }
    return res(ctx.json({}));
  }),
  rest.post(`${API_ROOT}current-medications`, (req, res, ctx) => res(ctx.json({ success: true }))),
  rest.put(`${API_ROOT}current-medications/reviewMedications=all`, (req, res, ctx) => res(ctx.json({ success: true }))),
  rest.put(`${API_ROOT}current-medications/3109`, (req, res, ctx) => res(ctx.json({ success: true }))),
];
export default CurrentMedications;
